import { RESET_TICKET_TIMER, START_TICKET_TIMER, STOP_TICKET_TIMER } from './Index';
export const _startTicketTimer = (
   startTime: number,
   ticketId: number | null | undefined,
   patientId: number,
   logId: number,
) => async (dispatch: any) => {
   dispatch({
      type: START_TICKET_TIMER,
      payload: {
         startTime: startTime,
         isTicketTimerRunning: true,
         ticketId: ticketId,
         patientId: patientId,
         logId: logId
      }
   });
};

export const _stopTicketTimer = (
   stopTime: any,
   stopTimer?: boolean
) => async (dispatch: any) => {
   const payload: any = {
      stopTime: stopTime
   };
   if (typeof stopTimer === 'boolean' && stopTime !== undefined) {
      payload.isTicketTimerRunning = stopTimer;
   }
   dispatch({
      type: STOP_TICKET_TIMER,
      payload: payload
   });
};

export const _resetTicketTimer = (): any => async (dispatch: any) => {
   dispatch({
      type: RESET_TICKET_TIMER
   });
};